import { createEvent, createStore } from 'effector';
import type { OnlineStatusFilter } from './clients-filter.entity';

export interface IMyFilter {
	onlineStatus: OnlineStatusFilter;
	removeWithoutPhone: boolean;
	removeRussianPhone: boolean;
	removeTgUsed: boolean;
	removeWithoutTgCode: boolean;
	removeWithTg2FA: boolean;
	removeTaken: boolean;
	time: string;
}

export const $setMyFilter = createEvent<IMyFilter>();
export const $updateMyFilter = createEvent<Partial<IMyFilter>>();

export const $myFilter = createStore<IMyFilter>({
	onlineStatus: 'online',
	removeRussianPhone: false,
	removeTgUsed: false,
	removeWithoutPhone: false,
	removeWithoutTgCode: false,
	removeWithTg2FA: false,
	removeTaken: false,
	time: '15m',
})
	.on($setMyFilter, (_, payload) => payload)
	.on($updateMyFilter, (state, payload) => ({ ...state, ...payload }));
